<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :fill="fill"
    :viewBox="viewbox"
    :stroke="stroke"
  >
    <component :is="name" />
  </svg>
</template>

<script>
import Grid from "@/icons/Grid";
import Heart from "@/icons/Heart";
import Search from "@/icons/Search";
import CreditCard from "@/icons/CreditCard";
import Logout from "@/icons/Logout";
import Setting from "@/icons/Setting";
import Support from "@/icons/Support";
import Adjustments from "@/icons/Adjustments";
import Close from "@/icons/Close";
import ArrowNarrowLeft from "@/icons/ArrowNarrowLeft";
import ArrowNarrowRight from "@/icons/ArrowNarrowRight";
import Selector from "@/icons/Selector";
import Check from "@/icons/Check";
import CursorClick from "@/icons/CursorClick";
import Fire from "@/icons/Fire";
import Refresh from "@/icons/Refresh";
import DocumentText from "@/icons/DocumentText";
import Clock from "@/icons/Clock";
import EmojiSad from "@/icons/EmojiSad";
import EmojiHappy from "@/icons/EmojiHappy";
import Exclamation from "@/icons/Exclamation";
import Ban from "@/icons/Ban";
import BadgeCheck from "@/icons/BadgeCheck";
import Filter from "@/icons/Filter";
import TredingUp from "@/icons/TredingUp";
import LockOpen from "@/icons/LockOpen";
import Laptop from "@/icons/Laptop";
import Lamp from "@/icons/Lamp";
import Favorite from "@/icons/Favorite";
import MenuHamburger from "@/icons/MenuHamburger";
import Tiktok from "@/icons/Tiktok";
import Facebook from "@/icons/Facebook";
import Instagram from "@/icons/Instagram";
import Question from "@/icons/Question";
import Time from "@/icons/Time";
import Brain from "@/icons/Brain";
import Information from "@/icons/Information";
import Web from "@/icons/Web";
import Window from "@/icons/Window";
import Video from "@/icons/Video";
import Contact from "@/icons/Contact";
import Location from "@/icons/Location";
import CurrencyUsd from "@/icons/CurrencyUsd";
import Twitter from "@/icons/Twitter";
import Email from "@/icons/Email";
import KnowledgeRequest from "@/icons/KnowledgeRequest";
import Affiliate from "@/icons/Affiliate";
export default {
  components: {
    LockOpen,
    TredingUp,
    Filter,
    BadgeCheck,
    Ban,
    Exclamation,
    EmojiSad,
    EmojiHappy,
    Clock,
    DocumentText,
    Refresh,
    Fire,
    CursorClick,
    Check,
    Selector,
    ArrowNarrowLeft,
    ArrowNarrowRight,
    Close,
    Grid,
    Heart,
    Search,
    CreditCard,
    Logout,
    Setting,
    Support,
    Adjustments,
    Laptop,
    Lamp,
    Favorite,
    MenuHamburger,
    Tiktok,
    Facebook,
    Instagram,
    Question,
    Time,
    Brain,
    Information,
    Web,
    Window,
    Video,
    Contact,
    Location,
    CurrencyUsd,
    Twitter,
    Email,
    KnowledgeRequest,
    Affiliate,
  },
  props: {
    name: {
      type: String,
    },
    fill: {
      type: String,
      default: "none",
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
    viewbox: {
      type: String,
      default: "0 0 24 24",
    },
  },
};
</script>

<style></style>
